/**
 * @generated SignedSource<<67d952660e09faf72b1b2d42e7d16918>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchPage_page$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"Breadcrumb_data">;
  } | null | undefined> | null | undefined;
  readonly id: string;
  readonly noResultsText: string;
  readonly path: string | null | undefined;
  readonly results: ReadonlyArray<{
    readonly headline: string;
    readonly snippet: string;
    readonly url: string;
  }>;
  readonly resultsTextPlural: string;
  readonly resultsTextSingular: string;
  readonly title: string;
  readonly " $fragmentType": "SearchPage_page";
};
export type SearchPage_page$key = {
  readonly " $data"?: SearchPage_page$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchPage_page">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "searchString"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SearchPage_page",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Breadcrumb",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Breadcrumb_data"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noResultsText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultsTextSingular",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resultsTextPlural",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "searchString",
          "variableName": "searchString"
        }
      ],
      "concreteType": "SearchResult",
      "kind": "LinkedField",
      "name": "results",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "snippet",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "SearchPage",
  "abstractKey": null
};

(node as any).hash = "1b47d44a828cf486effd3cd6d4d0abe9";

export default node;
